import { useState, useEffect } from "react"
import { useApp } from "../../context/useApp"
import { getProperty } from "../../actions/property-actions"
import { useParams, useNavigate, Link } from "react-router-dom"
import { formatDate } from "../../actions/global-actions"
import { updateRequest } from "../../actions/request-actions"
import { alert } from "../../components/Alert"
import {
  BsFileEarmarkPerson,
  BsHouseHeartFill,
  BsBriefcase,
  BsBank,
  BsPersonVcard,
  BsCheckCircleFill,
  BsXCircleFill,
  BsPencilSquare,
  BsPeople,
  BsHouse,
  BsCarFront,
  BsCreditCard,
  BsInfoCircle,
} from "react-icons/bs"
import "./see-request.css"

function SeeRequest() {
  const currentLink = "/inmuebles"
  const params = useParams()
  const { user, setLoading } = useApp()
  const [form, setForm] = useState({
    observation: "",
  })
  const [loadData, setLoadData] = useState(true)
  const [request, setRequest] = useState({})
  const [currentData, setCurrentData] = useState({})
  const [showWhatsappInfo, setShowWhatsappInfo] = useState(true)
  const navigate = useNavigate()

  useEffect(() => {
    if (loadData) {
      const fetchData = async () => {
        try {
          const data = await getProperty(params.id, setLoading, user.token)
          if (data.code === "01") {
            alert("Error", data.message)
            return
          }
          //console.log(data.data[0]);
          const requests = data.data[0].requests

          let request = requests.find(
            (requestObj) => requestObj._id === params.applyID,
          )

          console.log("request", request)

          if (request.monthlyExpenses) {
            request.monthlyExpenses = request.monthlyExpenses
              .toString()
              .replace(/\B(?=(\d{3})+(?!\d))/g, ".")
          }

          if (request.monthlyIncome) {
            request.monthlyIncome = request.monthlyIncome
              .toString()
              .replace(/\B(?=(\d{3})+(?!\d))/g, ".")
          }

          setCurrentData(data.data[0])
          setRequest(request)
          setForm({ observation: request.observation })
        } catch (error) {
          console.error(error)
        }
      }
      setLoadData(false)
      fetchData()
    }
  }, [loadData, params.id, user.token, params.applyID, setLoading])

  useEffect(() => {
    if (showWhatsappInfo) {
      const timer = setTimeout(() => {
        setShowWhatsappInfo(false)
      }, 10000)
      return () => clearTimeout(timer)
    }
  }, [showWhatsappInfo])

  const handleInputChange = (event) => {
    setForm({
      ...form,
      [event.target.name]: event.target.value,
    })
  }

  const handleRequestSubmit = (event, option) => {
    event.preventDefault()
    let currentRequest = currentData.requests.find(
      (request) => request.status === "Aprobado",
    )
    if (currentRequest) {
      let currentContract = currentRequest.contracts.find(
        (contract) => contract.status === "Activo",
      )
      //console.log('d', currentContract);
      if (currentContract) {
        alert(
          "Advertencia",
          "No puede modificar una solicitud mientras exista un contrato actualmente activo",
        )
        return
      }
    }

    if (
      window.confirm(
        `¿Realmente desea ${
          option === 1 ? "aprobar" : "rechazar"
        } esta solicitud? ${
          option === 1
            ? "TENGA EN CUENTA que si la aprueba se generará automáticamente un contrato de arrendamiento."
            : ""
        }`,
      )
    ) {
      let data = JSON.parse(JSON.stringify(currentData))
      let status = false
      for (let index = 0; index < data.requests.length; index++) {
        if (data.requests[index]._id === params.applyID) {
          if (option === 1) {
            data.requests[index].status = "En contrato"
            let contract = {
              startDate: new Date(),
              endDate: new Date(
                new Date().setFullYear(new Date().getFullYear() + 1),
              ),
              limitDay: "10",
              agreementTime: "Anual",
              monthlyCost: data.monthCost,
            }
            data.requests[index].contracts.push(contract)
            status = true
          } else {
            data.requests[index].status = "Rechazado"
          }
          data.requests[index].observation = form.observation
          break
        }
      }

      let toSend = {
        data,
        status,
      }
      //console.log('toSend', toSend);

      updateRequest(
        toSend,
        option === 1 ? acceptFunction : declineFunction,
        user.token,
      )
    }
  }

  const acceptFunction = (data) => {
    if (data.code === "01") {
      alert("Error", data.message)
      return
    }
    alert("¡Éxito!", "Solicitud aceptada con éxito")
    navigate(`${currentLink}/${params.id}/contratos`)
  }

  const declineFunction = (data) => {
    if (data.code === "01") {
      alert("Error", data.message)
      return
    }
    alert("¡Éxito!", "Solicitud rechazada con éxito")
    setLoadData(true)
  }

  useEffect(() => {
    //console.log('form', form);
    //console.log('currentData', currentData)
  }, [form, currentData])

  const calculateSeniority = (admissionDate) => {
    if (!admissionDate) return "N/A"
    const startDate = new Date(admissionDate)
    const today = new Date()
    let years = today.getFullYear() - startDate.getFullYear()
    const monthDiff = today.getMonth() - startDate.getMonth()

    if (
      monthDiff < 0 ||
      (monthDiff === 0 && today.getDate() < startDate.getDate())
    ) {
      years--
    }

    return years < 0 ? "0" : years.toString()
  }

  const renderFieldValue = (value) => {
    if (value === null || value === undefined || value === "") {
      return <span className="field-empty-state">No diligenciado</span>
    }
    return value
  }

  const renderPhoneField = (phone) => {
    if (phone === null || phone === undefined || phone === "") {
      return <span className="field-empty-state">No diligenciado</span>
    }
    // Limpiar el número de teléfono (quitar espacios, guiones, puntos, paréntesis)
    const cleanPhone = phone.toString().replace(/[\s\-\.\(\)]/g, "")
    // Crear el link de WhatsApp
    const whatsappLink = `https://wa.me/${cleanPhone}`
    return (
      <a
        href={whatsappLink}
        target="_blank"
        rel="noopener noreferrer"
        style={{
          color: "#25d366",
          textDecoration: "none",
          fontWeight: "500",
          cursor: "pointer",
          display: "inline-flex",
          alignItems: "center",
          gap: "6px",
        }}
        title="Abrir en WhatsApp"
      >
        {phone}
      </a>
    )
  }

  const RenderEmptySection = ({ section }) => {
    return (
      <div className="section-empty">
        <span className="field-empty-state">No cuenta con {section}</span>
      </div>
    )
  }

  const validateReferencesAreComplete = () => {
    if (!request.references || request.references.length === 0) {
      return false
    }
    return request.references.every(
      (ref) =>
        ref.type &&
        ref.type.trim() !== "" &&
        ref.fullname &&
        ref.fullname.trim() !== "" &&
        ref.phone &&
        ref.phone.trim() !== "" &&
        (ref.type.toLowerCase() === "comercial" ||
          (ref.relationship && ref.relationship.trim() !== "")),
    )
  }

  const validateCosignersAreComplete = () => {
    if (!request.cosigners || request.cosigners.length === 0) {
      return false
    }
    return request.cosigners.every(
      (cosigner) =>
        cosigner.firstName &&
        cosigner.firstName.trim() !== "" &&
        cosigner.lastName &&
        cosigner.lastName.trim() !== "" &&
        cosigner.documentType &&
        cosigner.documentType.trim() !== "" &&
        cosigner.document &&
        cosigner.document.toString().trim() !== "" &&
        cosigner.phone &&
        cosigner.phone.toString().trim() !== "" &&
        cosigner.email &&
        cosigner.email.trim() !== "" &&
        cosigner.address &&
        cosigner.address.trim() !== "" &&
        cosigner.cosignerCity &&
        cosigner.cosignerCity.trim() !== "" &&
        cosigner.cosignerProvince &&
        cosigner.cosignerProvince.trim() !== "",
    )
  }

  const getSummaryValidations = () => {
    const monthlyIncome = request.monthlyIncome
      ? parseInt(request.monthlyIncome.replace(/\D/g, ""))
      : 0
    const monthlyExpenses = request.monthlyExpenses
      ? parseInt(request.monthlyExpenses.replace(/\D/g, ""))
      : 0
    const monthlyCost = currentData.monthCost || 0

    // Calcular suma de fees de información financiera - solo si están diligenciados
    let totalFees = 0
    let hasCompleteFinancialInfo = false
    if (
      request.finantialInformation &&
      request.finantialInformation.length > 0
    ) {
      const completedFinances = request.finantialInformation.filter(
        (finance) => finance.fee && finance.fee.toString().trim() !== "",
      )
      hasCompleteFinancialInfo = completedFinances.length > 0
      totalFees = completedFinances.reduce((sum, finance) => {
        const fee = finance.fee
          ? parseInt(finance.fee.toString().replace(/\D/g, ""))
          : 0
        return sum + fee
      }, 0)
    }

    const availableIncome = monthlyIncome - monthlyExpenses - totalFees

    const validations = {
      incomeOutcome: {
        label:
          "Diferencia de ingresos vs gastos superior al costo del inmueble",
        valid: availableIncome > monthlyCost,
        details: `Ingresos: $${request.monthlyIncome || "0"} - Gastos: $${request.monthlyExpenses || "0"} - Cuotas: $${totalFees.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")} = $${availableIncome.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")} vs Costo: $${monthlyCost.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")}`,
      },
    }

    // Validación de referencias - solo si están incompletas
    const referencesComplete = validateReferencesAreComplete()
    const hasReferences = request.references && request.references.length > 0

    if (!referencesComplete && hasReferences) {
      validations.completeReferences = {
        label: "Todas las referencias están completas",
        valid: false,
        details: `${request.references.length} referencia(s)`,
        section: "Referencias",
      }
    }

    // Validación de codeudores - solo si están incompletos o si están completos y hay más de 1
    const cosignersComplete = validateCosignersAreComplete()
    const hasCosigners = request.cosigners && request.cosigners.length > 0
    const hasMultipleCosigners =
      request.cosigners && request.cosigners.length > 1

    if (!cosignersComplete && hasCosigners) {
      validations.completeCosigners = {
        label: "Todos los codeudores están completos",
        valid: false,
        details: `${request.cosigners.length} codeudor(es)`,
        section: "Codeudores",
      }
    }

    // Solo mostrar información financiera si tiene registros con fee diligenciado
    if (hasCompleteFinancialInfo) {
      validations.hasFinancialInfo = {
        label: "Tiene información financiera",
        valid: true,
        status: "warning",
        details: `${request.finantialInformation.filter((f) => f.fee && f.fee.toString().trim() !== "").length} registro(s) financiero(s)`,
      }
    }

    // Solo mostrar propiedades si tiene al menos una
    if (
      request.properties &&
      request.properties.length > 0 &&
      request.properties[0]?.type
    ) {
      validations.hasProperties = {
        label: "Cuenta con propiedades",
        valid: true,
        details: `${request.properties.length} propiedad(es)`,
        section: "Propiedades",
      }
    }

    // Solo mostrar codeudores si tiene más de 1
    if (request.cosigners && request.cosigners.length > 1) {
      validations.multipleCosigners = {
        label: "Tiene más de un codeudor",
        valid: true,
        details: `${request.cosigners.length} codeudor(es)`,
      }
    }

    return validations
  }

  return (
    <div className="see-request-container">
      {request && Object.keys(request).length > 0 ? (
        <div className="see-request-wrapper">
          {/* Back Button */}
          <div className="mb-4" style={{ marginTop: "1rem" }}>
            <button onClick={() => navigate(-1)} className="back-btn">
              ← Volver
            </button>
          </div>

          {/* WhatsApp Info Message */}
          {showWhatsappInfo && (
            <div
              style={{
                padding: "12px 16px",
                marginBottom: "1rem",
                backgroundColor: "#e8f5e9",
                border: "2px solid #4caf50",
                borderRadius: "6px",
                display: "flex",
                alignItems: "center",
                gap: "10px",
                animation: "fadeInOut 0.3s ease-in-out",
              }}
            >
              <BsInfoCircle
                style={{ fontSize: "20px", color: "#4caf50", flexShrink: 0 }}
              />
              <span style={{ color: "#2e7d32", fontWeight: "500" }}>
                Puedes hacer clic en los números de teléfono para iniciar una
                conversación en WhatsApp
              </span>
            </div>
          )}

          {/* Header Card */}
          <div className="request-header">
            <div className="header-top">
              <div>
                <h1 className="request-title">
                  {request.firstName} {request.lastName}
                </h1>
                <p
                  style={{
                    color: "#999",
                    margin: "0.5rem 0 0 0",
                    fontSize: "0.9rem",
                  }}
                >
                  {request.documentType} No. {request.document}
                </p>
              </div>
              <div className="header-right">
                <div className="status-container">
                  <span className="status-label">Estado</span>
                  <span
                    className={`request-status-badge status-badge ${request.status?.toLowerCase().replace(/ /g, "-")}`}
                  >
                    {request.status}
                  </span>
                </div>
                <div className="date-container">
                  <span className="info-value highlight">
                    Fecha de solicitud: {formatDate(request.createdAt, 4)}
                  </span>
                </div>
              </div>
            </div>

            {/* Quick Info & General Data Combined */}
            <div className="applicant-info">
              <div className="info-item">
                <span className="info-label">Email</span>
                <span className="info-value">{request.email}</span>
              </div>
              <div className="info-item">
                <span className="info-label">Teléfono</span>
                <span className="info-value">
                  {renderPhoneField(request.phone)}
                </span>
              </div>
              <div className="info-item">
                <span className="info-label">Ocupación</span>
                <span className="info-value">
                  {renderFieldValue(request.occupation)}
                </span>
              </div>
              <div className="info-item">
                <span className="info-label">Tipo de Usuario</span>
                <span className="info-value">{request.userType}</span>
              </div>
              <div className="info-item">
                <span className="info-label">Dependientes</span>
                <span className="info-value">
                  {renderFieldValue(request.dependents)}
                </span>
              </div>
              <div className="info-item">
                <span className="info-label">Personas que vivirán</span>
                <span className="info-value">
                  {renderFieldValue(request.peopleWhoWillLive)}
                </span>
              </div>
              <div className="info-item">
                <span className="info-label">Gastos Mensuales</span>
                <span className="info-value highlight">
                  ${renderFieldValue(request.monthlyExpenses)}
                </span>
              </div>
              <div className="info-item">
                <span className="info-label">Ingresos Mensuales</span>
                <span className="info-value highlight">
                  ${renderFieldValue(request.monthlyIncome)}
                </span>
              </div>
              <div className="field-group" style={{ gridColumn: "1 / -1" }}>
                <span className="field-label">Declaración de fondos</span>
                <span className="field-value" style={{ fontStyle: "italic" }}>
                  {renderFieldValue(request.description)}
                </span>
              </div>
            </div>
          </div>

          {/* Property Information Section */}
          <div className="section-card property-card">
            <h3 className="section-title" title="Inmueble Objetivo">
              <BsHouse /> Inmueble Objetivo
            </h3>
            <div className="section-grid">
              <div className="field-group">
                <span className="field-label">Código</span>
                <span className="field-value">{currentData.code || "N/A"}</span>
              </div>
              <div className="field-group">
                <span className="field-label">Dirección</span>
                <span className="field-value">
                  {currentData.address || "N/A"}
                </span>
              </div>
              <div className="field-group">
                <span className="field-label">Barrio</span>
                <span className="field-value">
                  {currentData.neighborhood || "N/A"}
                </span>
              </div>
              <div className="field-group">
                <span className="field-label">Ciudad</span>
                <span className="field-value">{currentData.city || "N/A"}</span>
              </div>
              <div className="field-group">
                <span className="field-label">Departamento</span>
                <span className="field-value">
                  {currentData.province || "N/A"}
                </span>
              </div>
              <div className="field-group">
                <span className="field-label">Tipo de Propiedad</span>
                <span className="field-value">
                  {currentData.propertyType || "N/A"}
                </span>
              </div>
              <div className="field-group">
                <span className="field-label">Costo Mensual</span>
                <span className="field-value highlight">
                  $
                  {currentData.monthCost
                    ? currentData.monthCost
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ".")
                    : "N/A"}
                </span>
              </div>
            </div>
          </div>

          {/* Summary Section */}
          <div className="section-card" style={{ backgroundColor: "#f9f9f9" }}>
            <h3 className="section-title" title="Resumen">
              <BsCheckCircleFill /> Resumen
            </h3>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "12px",
              }}
            >
              {Object.entries(getSummaryValidations()).map(
                ([key, validation]) => {
                  const isWarning = validation.status === "warning"
                  const borderColor = isWarning
                    ? "#f59e0b"
                    : validation.valid
                      ? "#22c55e"
                      : "#ef4444"
                  const bgColor = isWarning
                    ? "#fffbeb"
                    : validation.valid
                      ? "#f0fdf4"
                      : "#fef2f2"
                  const textColor = isWarning
                    ? "#d97706"
                    : validation.valid
                      ? "#16a34a"
                      : "#dc2626"
                  const symbol = isWarning ? "!" : validation.valid ? "✓" : "✗"
                  const isClickable =
                    key === "hasFinancialInfo" ||
                    key === "completeReferences" ||
                    key === "completeCosigners" ||
                    key === "hasProperties"

                  return (
                    <div
                      key={key}
                      style={{
                        padding: "12px",
                        borderRadius: "6px",
                        border: `2px solid ${borderColor}`,
                        backgroundColor: bgColor,
                        display: "flex",
                        alignItems: "center",
                        gap: "12px",
                        cursor: isClickable ? "pointer" : "default",
                      }}
                      onClick={() => {
                        if (isClickable) {
                          const sectionTitle =
                            validation.section || "Información Financiera"
                          const section = document.querySelector(
                            `[title="${sectionTitle}"]`,
                          )
                          if (section) {
                            section.scrollIntoView({
                              behavior: "smooth",
                              block: "start",
                            })
                          }
                        }
                      }}
                    >
                      <div
                        style={{
                          fontSize: "20px",
                          minWidth: "24px",
                          fontWeight: "bold",
                        }}
                      >
                        {symbol}
                      </div>
                      <div style={{ flex: 1 }}>
                        <div
                          style={{
                            fontWeight: "600",
                            color: textColor,
                            marginBottom: "4px",
                          }}
                        >
                          {validation.label}
                        </div>
                        <div style={{ fontSize: "0.9rem", color: "#666" }}>
                          {validation.details}
                        </div>
                      </div>
                    </div>
                  )
                },
              )}
            </div>
          </div>

          {/* Current Property */}
          <div className="section-card">
            <h3 className="section-title" title="Vivienda Actual">
              <BsHouseHeartFill /> Vivienda Actual
            </h3>
            <div className="section-grid">
              <div className="field-group">
                <span className="field-label">Tipo de Propiedad</span>
                <span className="field-value">
                  {renderFieldValue(request.actualProperty.type)}
                </span>
              </div>
              <div className="field-group">
                <span className="field-label">Dirección</span>
                <span className="field-value">
                  {renderFieldValue(request.actualProperty.address)}
                </span>
              </div>
              <div className="field-group">
                <span className="field-label">Barrio</span>
                <span className="field-value">
                  {renderFieldValue(request.actualProperty.neighborhood)}
                </span>
              </div>
              <div className="field-group">
                <span className="field-label">Ciudad</span>
                <span className="field-value">
                  {renderFieldValue(request.actualProperty.actualPropertyCity)}
                </span>
              </div>
              <div className="field-group">
                <span className="field-label">Provincia</span>
                <span className="field-value">
                  {renderFieldValue(
                    request.actualProperty.actualPropertyProvince,
                  )}
                </span>
              </div>
              <div className="field-group">
                <span className="field-label">Propietario/Administrador</span>
                <span className="field-value">
                  {renderFieldValue(request.actualProperty.landlord)}
                </span>
              </div>
              <div className="field-group">
                <span className="field-label">Teléfono Propietario</span>
                <span className="field-value">
                  {renderPhoneField(request.actualProperty.landlordPhone)}
                </span>
              </div>
              <div className="field-group">
                <span className="field-label">Costo Mensual</span>
                <span className="field-value highlight">
                  $
                  {request.actualProperty.monthlyCost
                    ? request.actualProperty.monthlyCost
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ".")
                    : renderFieldValue(null)}
                </span>
              </div>
            </div>
          </div>

          {/* Employment Section */}
          {request.userType === "Empleado" && request.employee && (
            <div className="section-card">
              <h3 className="section-title" title="Información de Empleo">
                <BsBriefcase /> Información de Empleo
              </h3>
              <div className="section-grid">
                <div className="field-group">
                  <span className="field-label">Empresa</span>
                  <span className="field-value">
                    {renderFieldValue(request.employee.company)}
                  </span>
                </div>
                <div className="field-group">
                  <span className="field-label">Cargo</span>
                  <span className="field-value">
                    {renderFieldValue(request.employee.position)}
                  </span>
                </div>
                <div className="field-group">
                  <span className="field-label">Salario</span>
                  <span className="field-value highlight">
                    $
                    {request.employee.salary
                      ? request.employee.salary
                          .toString()
                          .replace(/\B(?=(\d{3})+(?!\d))/g, ".")
                      : renderFieldValue(null)}
                  </span>
                </div>
                <div className="field-group">
                  <span className="field-label">Fecha de ingreso</span>
                  <span className="field-value">
                    {request.employee.admissionDay
                      ? formatDate(request.employee.admissionDay, 4)
                      : renderFieldValue(null)}
                  </span>
                </div>
                <div className="field-group">
                  <span className="field-label">Antigüedad</span>
                  <span className="field-value highlight">
                    {request.employee.admissionDay
                      ? `${calculateSeniority(request.employee.admissionDay)} años`
                      : renderFieldValue(null)}
                  </span>
                </div>
                <div className="field-group">
                  <span className="field-label">Dirección</span>
                  <span className="field-value">
                    {renderFieldValue(request.employee.address)}
                  </span>
                </div>
              </div>
            </div>
          )}

          {/* Independent Section */}
          {request.userType === "Independiente" && request.independent && (
            <div className="section-card">
              <h3 className="section-title" title="Información Independiente">
                <BsBank /> Información Independiente
              </h3>
              <div className="section-grid">
                <div className="field-group">
                  <span className="field-label">Actividad</span>
                  <span className="field-value">
                    {renderFieldValue(request.independent.activity)}
                  </span>
                </div>
                <div className="field-group">
                  <span className="field-label">Ingresos</span>
                  <span className="field-value highlight">
                    $
                    {request.independent.income
                      ? request.independent.income
                          .toString()
                          .replace(/\B(?=(\d{3})+(?!\d))/g, ".")
                      : renderFieldValue(null)}
                  </span>
                </div>
                <div className="field-group">
                  <span className="field-label">Egresos</span>
                  <span className="field-value">
                    $
                    {request.independent.expenses
                      ? request.independent.expenses
                          .toString()
                          .replace(/\B(?=(\d{3})+(?!\d))/g, ".")
                      : renderFieldValue(null)}
                  </span>
                </div>
              </div>
            </div>
          )}

          {/* Pensioner Section */}
          {request.userType === "Pensionado" && request.pensionary && (
            <div className="section-card">
              <h3 className="section-title" title="Información de Pensión">
                <BsFileEarmarkPerson /> Información de Pensión
              </h3>
              <div className="section-grid">
                <div className="field-group">
                  <span className="field-label">Razón</span>
                  <span className="field-value">
                    {renderFieldValue(request.pensionary.reason)}
                  </span>
                </div>
                <div className="field-group">
                  <span className="field-label">Valor de Pensión</span>
                  <span className="field-value highlight">
                    $
                    {request.pensionary.value
                      ? request.pensionary.value
                          .toString()
                          .replace(/\B(?=(\d{3})+(?!\d))/g, ".")
                      : renderFieldValue(null)}
                  </span>
                </div>
              </div>
            </div>
          )}

          {/* Properties Section */}
          <div className="section-card">
            <h3 className="section-title" title="Propiedades">
              <BsHouse /> Propiedades
            </h3>
            {request.properties &&
            request.properties.length > 0 &&
            request.properties[0]?.type ? (
              <>
                {request.properties.map((property, index) => (
                  <div key={index}>
                    {request.properties.length > 1 && (
                      <div className="nested-header">Propiedad {index + 1}</div>
                    )}
                    <div className="nested-grid">
                      <div className="field-group">
                        <span className="field-label">Tipo</span>
                        <span className="field-value">{property.type}</span>
                      </div>
                      <div className="field-group">
                        <span className="field-label">Dirección</span>
                        <span className="field-value">
                          {property.address} {property.propertyCity},{" "}
                          {property.propertyProvince}
                        </span>
                      </div>
                      <div className="field-group">
                        <span className="field-label">Valor</span>
                        <span className="field-value highlight">
                          $
                          {property.value
                            .toString()
                            .replace(/\B(?=(\d{3})+(?!\d))/g, ".")}
                        </span>
                      </div>
                      <div className="field-group">
                        <span className="field-label">Matrícula</span>
                        <span className="field-value">
                          {property.realEstateRegistration}
                        </span>
                      </div>
                    </div>
                  </div>
                ))}
              </>
            ) : (
              <RenderEmptySection section="Propiedades" />
            )}
          </div>

          {/* Vehicles Section */}
          <div className="section-card">
            <h3 className="section-title" title="Vehículos">
              <BsCarFront /> Vehículos
            </h3>
            {request.vehicles &&
            request.vehicles.length > 0 &&
            request.vehicles[0]?.type ? (
              <>
                {request.vehicles.map((vehicle, index) => (
                  <div key={index}>
                    {request.vehicles.length > 1 && (
                      <div className="nested-header">Vehículo {index + 1}</div>
                    )}
                    <div className="nested-grid">
                      <div className="field-group">
                        <span className="field-label">Tipo</span>
                        <span className="field-value">{vehicle.type}</span>
                      </div>
                      <div className="field-group">
                        <span className="field-label">Marca</span>
                        <span className="field-value">
                          {renderFieldValue(vehicle.brand)}
                        </span>
                      </div>
                      <div className="field-group">
                        <span className="field-label">Modelo</span>
                        <span className="field-value">
                          {renderFieldValue(vehicle.model)}
                        </span>
                      </div>
                      <div className="field-group">
                        <span className="field-label">Placa</span>
                        <span className="field-value">
                          {renderFieldValue(vehicle.plaque)}
                        </span>
                      </div>
                    </div>
                  </div>
                ))}
              </>
            ) : (
              <RenderEmptySection section="Vehículos" />
            )}
          </div>

          {/* Financial Information Section */}
          <div className="section-card">
            <h3 className="section-title" title="Información Financiera">
              <BsCreditCard /> Información Financiera
            </h3>
            {request.finantialInformation &&
            request.finantialInformation.length > 0 &&
            request.finantialInformation[0]?.type ? (
              <>
                {request.finantialInformation.map((finance, index) => (
                  <div key={index}>
                    {request.finantialInformation.length > 1 && (
                      <div className="nested-header">
                        Información Financiera {index + 1}
                      </div>
                    )}
                    <div className="nested-grid">
                      <div className="field-group">
                        <span className="field-label">Tipo</span>
                        <span className="field-value">{finance.type}</span>
                      </div>
                      <div className="field-group">
                        <span className="field-label">Entidad</span>
                        <span className="field-value">
                          {renderFieldValue(finance.entity)}
                        </span>
                      </div>
                      <div className="field-group">
                        <span className="field-label">Valor</span>
                        <span className="field-value highlight">
                          $
                          {finance.value
                            ? finance.value
                                .toString()
                                .replace(/\B(?=(\d{3})+(?!\d))/g, ".")
                            : renderFieldValue(null)}
                        </span>
                      </div>
                      <div className="field-group">
                        <span className="field-label">Cuota</span>
                        <span className="field-value">
                          $
                          {finance.fee
                            ? finance.fee
                                .toString()
                                .replace(/\B(?=(\d{3})+(?!\d))/g, ".")
                            : renderFieldValue(null)}
                        </span>
                      </div>
                      <div className="field-group">
                        <span className="field-label">Saldo Restante</span>
                        <span className="field-value">
                          $
                          {finance.remaining
                            ? finance.remaining
                                .toString()
                                .replace(/\B(?=(\d{3})+(?!\d))/g, ".")
                            : renderFieldValue(null)}
                        </span>
                      </div>
                    </div>
                  </div>
                ))}
              </>
            ) : (
              <RenderEmptySection section="Información Financiera" />
            )}
          </div>

          {/* References Section */}
          <div className="section-card">
            <h3 className="section-title" title="Referencias">
              <BsPeople /> Referencias
            </h3>
            {request.references &&
            request.references.length > 0 &&
            request.references[0]?.fullname ? (
              <>
                {request.references.map((reference, index) => (
                  <div key={index}>
                    {request.references.length > 1 && (
                      <div className="nested-header">
                        Referencia {index + 1}
                      </div>
                    )}
                    <div className="nested-grid">
                      <div className="field-group">
                        <span className="field-label">Tipo</span>
                        <span className="field-value">{reference.type}</span>
                      </div>
                      <div className="field-group">
                        <span className="field-label">Nombre Completo</span>
                        <span className="field-value">
                          {renderFieldValue(reference.fullname)}
                        </span>
                      </div>
                      <div className="field-group">
                        <span className="field-label">Teléfono</span>
                        <span className="field-value">
                          {renderPhoneField(reference.phone)}
                        </span>
                      </div>
                      {reference.type &&
                        reference.type.toLowerCase() !== "comercial" && (
                          <div className="field-group">
                            <span className="field-label">Relación</span>
                            <span className="field-value">
                              {renderFieldValue(reference.relationship)}
                            </span>
                          </div>
                        )}
                    </div>
                  </div>
                ))}
              </>
            ) : (
              <RenderEmptySection section="Referencias" />
            )}
          </div>

          {/* Co-signers Section */}
          <div className="section-card">
            <h3 className="section-title" title="Codeudores">
              <BsPersonVcard /> Codeudores
            </h3>
            {request.cosigners && request.cosigners.length > 0 ? (
              <>
                {request.cosigners.map((cosigner, index) => (
                  <div key={index}>
                    {request.cosigners.length > 1 && (
                      <div className="nested-header">Codeudor {index + 1}</div>
                    )}
                    <div className="nested-grid">
                      <div className="field-group">
                        <span className="field-label">Nombre</span>
                        <span className="field-value">
                          {cosigner.firstName} {cosigner.lastName}
                        </span>
                      </div>
                      <div className="field-group">
                        <span className="field-label">Documento</span>
                        <span className="field-value">
                          {cosigner.documentType} No. {cosigner.document}
                        </span>
                      </div>
                      <div className="field-group">
                        <span className="field-label">Teléfono</span>
                        <span className="field-value">
                          {renderPhoneField(cosigner.phone)}
                        </span>
                      </div>
                      <div className="field-group">
                        <span className="field-label">Email</span>
                        <span className="field-value">{cosigner.email}</span>
                      </div>
                      <div className="field-group">
                        <span className="field-label">Residencia</span>
                        <span className="field-value">
                          {cosigner.address}, {cosigner.cosignerCity},
                          {cosigner.cosignerProvince}
                        </span>
                      </div>
                    </div>
                  </div>
                ))}
              </>
            ) : (
              <RenderEmptySection section="Codeudores" />
            )}
          </div>

          {/* Observation Section */}
          <div className="observation-section">
            <h3 className="observation-title">
              <BsPencilSquare /> Observación del Administrador
            </h3>
            <textarea
              id="observation"
              name="observation"
              className="observation-textarea"
              placeholder="Dé una retroalimentación acerca de esta solicitud..."
              onChange={handleInputChange}
              value={form.observation}
            ></textarea>
          </div>

          {/* Action Buttons */}
          {(request.status === "Pendiente" ||
            request.status === "Aprobado" ||
            request.status === "Rechazado") && (
            <div className="action-buttons">
              {request.status === "Pendiente" && (
                <>
                  <button
                    className="action-btn btn-reject"
                    onClick={(e) => handleRequestSubmit(e, 2)}
                  >
                    <BsXCircleFill /> Rechazar
                  </button>
                  <button
                    className="action-btn btn-approve"
                    onClick={(e) => handleRequestSubmit(e, 1)}
                  >
                    <BsCheckCircleFill /> Aprobar
                  </button>
                </>
              )}
              {request.status === "Aprobado" && (
                <button
                  className="action-btn btn-reject"
                  onClick={(e) => handleRequestSubmit(e, 2)}
                >
                  <BsXCircleFill /> Rechazar
                </button>
              )}
              {request.status === "Rechazado" && (
                <button
                  className="action-btn btn-approve"
                  onClick={(e) => handleRequestSubmit(e, 1)}
                >
                  <BsCheckCircleFill /> Aprobar
                </button>
              )}
            </div>
          )}
        </div>
      ) : (
        <div className="loading-state">
          <p>Cargando solicitud...</p>
        </div>
      )}
    </div>
  )
}

export default SeeRequest
